function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E1E9F0",
  fillRule: "evenodd",
  d: "M2.37 6.905l3.106 3.107a5.61 5.61 0 00-1.385 3.624c.054 3.052 2.49 5.487 5.454 5.455a5.29 5.29 0 003.625-1.386l2.617 2.618-.092.159a10.186 10.186 0 011.893 2.088l.221.34c.584.898 1.064 1.86 1.431 2.865l.15.434v.068c.55-.22 1.078-.476 1.584-.768l2.12 2.122A14.93 14.93 0 0115 30C6.716 30 0 23.284 0 15c0-2.981.87-5.76 2.37-8.095zm.197-5.701l.093.081 26.163 26.24a.974.974 0 01-1.283 1.458l-.093-.082L1.284 2.661a.974.974 0 011.283-1.457zm6.978 18.8a7.84 7.84 0 00-4.786 1.364C6.97 24.895 10.838 27.106 15 27.11c.917.005 1.831-.09 2.727-.286-1.145-3.75-3.504-6.818-8.182-6.818zM15 0a15 15 0 0115 15c0 3-.88 5.794-2.397 8.138l-2.132-2.131c.285-.495.536-1.012.752-1.548a6.177 6.177 0 00-4.425-2.127l-.987-.984c.107.01.216.016.325.016 1.883 0 3.41-1.545 3.41-3.45-.044-1.873-1.557-3.37-3.41-3.369-1.852 0-3.366 1.496-3.409 3.37 0 .124.007.246.02.367L6.861 2.397A14.93 14.93 0 0115 0z"
});

var SvgEmptyPerson = function SvgEmptyPerson(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref);
};

export default SvgEmptyPerson;